import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import { applyStoredToken } from './modules/auth/api/authService';

// The real production site must never print to the console - beyond noise, some call sites log
// full user objects (including the JWT session token) for debugging, which would otherwise leak
// into production devtools. console.error is left intact so real crashes are still
// visible/reportable.
//
// NODE_ENV is NOT the right signal here: CRA sets it to "production" for every `npm run build`
// output, including the dev deployment (dev-epermit.irpc.in.th), since dev is also served from an
// optimized build rather than `npm start` - gating on NODE_ENV would silently kill console
// logging on dev too. REACT_APP_ASPNETCORE_ENVIRONMENT is baked in per-environment from
// .env.dev/.env.production and actually distinguishes them.
if (process.env.REACT_APP_ASPNETCORE_ENVIRONMENT === 'Production') {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

applyStoredToken();
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
